import { render, staticRenderFns } from "./DocumentPage.vue?vue&type=template&id=79cf2eab&scoped=true&"
import script from "./DocumentPage.vue?vue&type=script&lang=ts&"
export * from "./DocumentPage.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentPage.vue?vue&type=style&index=0&id=79cf2eab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cf2eab",
  null
  
)

export default component.exports